import { useMemo } from "react";
import Text from "hardcover-ui/components/Text";
import pluralize from "lib/pluralize";
import { oxfordCommaList } from "lib/array";
import LocaleNumber from "components/ui/LocaleNumber";
import LocalizedDate from "components/shared/LocalizedDate";
import { SeriesSerializersSeriesGroup } from "types/serializers";

const MAX_AUTHORS = 10;
export default function AboutSeries({ series }: { series: SeriesSerializersSeriesGroup }) {

  const authorList = useMemo(() => {
    const numAuthors = series.topAuthorNames.length;
    if (numAuthors <= MAX_AUTHORS) {
      return oxfordCommaList(series.topAuthorNames);
    } else {
      const authors = series.topAuthorNames.slice(0, MAX_AUTHORS);
      const remainder = numAuthors - MAX_AUTHORS;
      return `${authors.join(', ')} and ${remainder} ${pluralize('other', remainder)}`;
    }
  }, [ series.topAuthorNames ]);

  return (
    <Text variant="secondary" as="p">
      {series.name} is a{" "}
      <b><LocaleNumber number={series.releasedBooksCount} />-book series</b>{" "}
      {series.releasedBooksCount > 1 && series.primaryReleasedBooksCount ? (
        <>
          with{" "}
          <b>{series.primaryReleasedBooksCount} {pluralize("released primary work", series.primaryBooksCount)}</b>{" "}
        </>
      ) : (
        <></>
      )}
      {series.firstReleaseYear && <>first released in {series.firstReleaseYear} </>}
      {series.topAuthorNames.length > 0 && (
        <>with contributions by {authorList}</>
      )}
      .
      {series.unrelesedBooksCount > 0 && (
        <>{" "}
          <b>
            <LocaleNumber number={series.unrelesedBooksCount} />{" "}
            {pluralize("book", series.unrelesedBooksCount)}
          </b>{" "}
          {series.unrelesedBooksCount === 1 ? "is" : "are"} still to be released.
        </>
      )}
      {series.nextReleaseDate && (
        <>
          {" "}
          The next book is scheduled for release on{" "}
          <LocalizedDate date={series.nextReleaseDate} />.
        </>
      )}
    </Text>
  );
}
